import Grid from '@material-ui/core/Grid'
import React from 'react'
import { Route, Switch } from 'react-router-dom'
import CognitoLogin from '../../account/components/login'
import ChangePassword from '../../account/components/changePassword'
import ResetPassword from '../../account/components/resetPassword'
import CompanySettings from '../../account/components/companySettings'
import MinWageUserPreferences from '../../minWage/components/userPreferences'
import PaidLeaveUserPreferences from '../../paidLeave/components/userPreferences'
import Modal from '../../common/components/modal'
import Alert from '../../common/components/alert'
import Banner from '../../common/components/notification'
import Compliance from '../../compliance/components/dashboard'
import PostingsLocations from '../../compliance/components/PostingsLocations'
import PostersMap from '../../compliance/components/postersMap'
import ComplianceShipments from '../../compliance/components/statelessShipmentsTable'
import ComplianceUpdates from '../../compliance/components/updateTable'
import MinWage from '../../minWage/components/dashboard'
import MinWageDetail from '../../minWage/components/detail/MinWageDetail'
import MinWageLocations from '../../minWage/components/statelessLocationTable'
import MinWageNotifications from '../../minWage/components/notifications/components/table/index'
import ComplianceHelp from '../../compliance/components/help'
import MinWageHelp from '../../minWage/components/help'
import SelectCompany from '../../account/components/selectCompany'
import CompanySwitch from './companySwitch/index'
import PaidLeave from '../../paidLeave/components/dashboard'
import PaidLeaveLocations from '../../paidLeave/components/paidLeaveLocationsTable/components/table'
import PaidLeaveDetail from '../../paidLeave/components/detail'
import PaidLeaveNotifications from '../../paidLeave/components/notifications/components/table'
import PaidLeaveSummary from '../../paidLeave/components/summary/components/table'
import { maxAppWidth } from '../../theme/Global'
import Footer from './footer'
import MainToolBar from './mainToolBar'
import { PaidLeaveProvider } from '../../context/paidLeaveProvider'
import { LocationsProvider } from '../../context/locationsProvider'
import { useAuth, ProvideAuth } from '../../auth/useAuth'
import DefaultErrorBoundary from '../../common/components/ErrorBoundary'
import PosterCheck from '../../posterCheck'
import IppPostings from '../../ippPostings'

const gridStyles = {
  maxWidth: maxAppWidth,
  alignSelf: 'center',
  flex: '1 1 auto',
  flexDirection: 'row',
  marginBottom: '3rem',
  height: '100%'
}

export const WrapInErrorBoundary = (Component) => (props) => (<DefaultErrorBoundary><Component {...props} /></DefaultErrorBoundary>)

const Authenticated = () => {
  const { user, company } = useAuth()
  return (
    // eslint-disable-next-line react/jsx-fragments
    <React.Fragment>
      <Banner />
      <Route path="/" component={MainToolBar} />
      <Grid container spacing={0} style={gridStyles}>
        <Grid item xs={12}>
          {/* todo: toast provider goes here -- ELM-2139 */}
          <Route exact path="/compliance" component={WrapInErrorBoundary(Compliance)} />
          <Route exact path="/compliance/help" component={WrapInErrorBoundary(ComplianceHelp)} />
          <Route exact path="/compliance/help/:section" component={WrapInErrorBoundary(ComplianceHelp)} />
          <Route exact path="/compliance/locations" component={WrapInErrorBoundary(PostingsLocations)} />
          <Route exact path="/compliance/posters" component={WrapInErrorBoundary(PostersMap)} />
          <Route exact path="/compliance/settings" component={WrapInErrorBoundary(CompanySettings)} />
          <Route exact path="/compliance/shipments" component={WrapInErrorBoundary(ComplianceShipments)} />
          <Route exact path="/compliance/updates" component={WrapInErrorBoundary(ComplianceUpdates)} />
          <Route exact path="/compliance/companies/switch" component={WrapInErrorBoundary(CompanySwitch)} />
          <Route exact path="/selectCompany" component={() => <SelectCompany {...{ user, company }} />} />
          <LocationsProvider>
            <Route exact path="/minWage" component={WrapInErrorBoundary(MinWage)} />
            <Route exact path="/minWage/details/:id" component={WrapInErrorBoundary(MinWageDetail)} />
            <Route exact path="/minWage/help" component={WrapInErrorBoundary(MinWageHelp)} />
            <Route exact path="/minWage/locations" component={WrapInErrorBoundary(MinWageLocations)} />
            <Route exact path="/minWage/notifications" component={WrapInErrorBoundary(MinWageNotifications)} />
            <Route exact path="/minWage/settings" component={WrapInErrorBoundary(CompanySettings)} />
            <Route exact path="/minWage/user-preferences" component={WrapInErrorBoundary(MinWageUserPreferences)} />
          </LocationsProvider>
          <PaidLeaveProvider>
            <Route exact path="/paidLeave" component={WrapInErrorBoundary(PaidLeave)} />
            <Route exact path="/paidLeave/locations" component={WrapInErrorBoundary(PaidLeaveLocations)} />
            <Route exact path="/paidLeave/details/:id" component={WrapInErrorBoundary(PaidLeaveDetail)} />
            <Route exact path="/paidLeave/notifications" component={WrapInErrorBoundary(PaidLeaveNotifications)} />
            <Route exact path="/paidLeave/summary" component={WrapInErrorBoundary(PaidLeaveSummary)} />
            <Route exact path="/paidLeave/user-preferences" component={WrapInErrorBoundary(PaidLeaveUserPreferences)} />
          </PaidLeaveProvider>
          <Modal />
          <Alert />
        </Grid>
      </Grid>
      <Footer />
    </React.Fragment>
  )
}

const AppRenderer = () => (
  <Switch>
    <ProvideAuth>
      <Route exact path="/" component={CognitoLogin} />
      <Route exact path="/change-password" component={ChangePassword} />
      <Route exact path="/reset-password" component={ResetPassword} />
      <Route exact path="/posterCheck" component={PosterCheck} />
      <Route exact path="/ippPostings" component={IppPostings} />
      <Route path="/" component={Authenticated} />
    </ProvideAuth>
  </Switch>
)

export default AppRenderer
